/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Company_BriefsInputs */

const en_pricing_compare_company_briefs = /** @type {(inputs: Pricing_Compare_Company_BriefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company briefs`)
};

const de_pricing_compare_company_briefs = /** @type {(inputs: Pricing_Compare_Company_BriefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmenszusammenfassungen`)
};

const fr_pricing_compare_company_briefs = /** @type {(inputs: Pricing_Compare_Company_BriefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiches entreprise`)
};

const es_pricing_compare_company_briefs = /** @type {(inputs: Pricing_Compare_Company_BriefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informes de empresa`)
};

const it_pricing_compare_company_briefs = /** @type {(inputs: Pricing_Compare_Company_BriefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info aziende`)
};

const nl_pricing_compare_company_briefs = /** @type {(inputs: Pricing_Compare_Company_BriefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedrijfsnotities`)
};

const pl_pricing_compare_company_briefs = /** @type {(inputs: Pricing_Compare_Company_BriefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opisy firm`)
};

const fi_pricing_compare_company_briefs = /** @type {(inputs: Pricing_Compare_Company_BriefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yrityksen esittelyt`)
};

const da_pricing_compare_company_briefs = /** @type {(inputs: Pricing_Compare_Company_BriefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firmaoversigter`)
};

const sv_pricing_compare_company_briefs = /** @type {(inputs: Pricing_Compare_Company_BriefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Företagsöversikter`)
};

/**
* | output |
* | --- |
* | "Company briefs" |
*
* @param {Pricing_Compare_Company_BriefsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_company_briefs = /** @type {((inputs?: Pricing_Compare_Company_BriefsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Company_BriefsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_company_briefs(inputs)
	if (locale === "fr") return fr_pricing_compare_company_briefs(inputs)
	if (locale === "es") return es_pricing_compare_company_briefs(inputs)
	if (locale === "it") return it_pricing_compare_company_briefs(inputs)
	if (locale === "nl") return nl_pricing_compare_company_briefs(inputs)
	if (locale === "pl") return pl_pricing_compare_company_briefs(inputs)
	if (locale === "fi") return fi_pricing_compare_company_briefs(inputs)
	if (locale === "da") return da_pricing_compare_company_briefs(inputs)
	if (locale === "sv") return sv_pricing_compare_company_briefs(inputs)
	return en_pricing_compare_company_briefs(inputs)
});